import React, { Component } from 'react'
import PropTypes from 'prop-types';
import './author.scss';

const AUTHORS = {
  'Liam Brooks': {
    image_url: '/img/authors/Liam-Brooks-1.jpg',
    about: 'Automotive Expert',
    fb_page: 'https://www.facebook.com/liam.brooks.older'
  },
  'Jim Comey': {
    image_url: '/img/authors/Jim-Comey-2.jpg',
    about: 'Automotive Expert',
    fb_page: 'https://www.facebook.com/liam.brooks.older'
  }
}

class Author extends Component {
  render() {
    const name = this.props.name ? this.props.name : "Liam Brooks";
    const created = this.props.created;
    const updated = this.props.updated;
    const updatedDate = new Date(updated);

    return (
      <div className="author">
        <div className="author__wrapper">
          <div className="author__image-wrapper">
            <amp-img
              class="author__image"
              src={AUTHORS[name].image_url}
              width="65"
              height="65"
              layout="flex-item"
              alt={name}
            ></amp-img>
          </div>
          <div className="author__content">
            <address>
              by <a className="author__name" href={AUTHORS[name].fb_page} rel="author">{name}</a>  · <span className="author__about" >{AUTHORS[name].about}</span>
            </address>
            <div className="author__created">
              Published <time pubdate dateTime={created} title={created}>{created}</time>
            </div>
            <div className="author__updated ga-test">
              Updated <time pubdate dateTime={updated} title={updated}>{updatedDate.toLocaleString('en-US', { month: "long" })} {updatedDate.getFullYear()}</time>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Author.propTypes = {
  name: PropTypes.string,
  created: PropTypes.string,
  updated: PropTypes.string,
};

export default Author;



// WEBPACK FOOTER //
// ./src/components/author/author.js